const baseUrl1 = process.env.NODE_ENV === 'development' ? `/crm-user` : `/crm/crm-user`;
const baseUrl2 = process.env.NODE_ENV === 'development' ? `/crm-approve` :`/crm/crm-approve`;
const baseUrl3 = process.env.NODE_ENV === 'development' ? `/crm-resume` :`/crm/crm-resume`;
const baseUrl4 = process.env.NODE_ENV === 'development' ? `/crm-project` :`/crm/crm-project`;
const baseUrl5 = process.env.NODE_ENV === 'development' ? `/crm-common` :`/crm/crm-common`;
const baseUrl6 = process.env.NODE_ENV === 'development' ? `/crm-schedule` :`/crm/crm-schedule`;

export {
  baseUrl1,
  baseUrl2,
  baseUrl3,
  baseUrl4,
  baseUrl5,
  baseUrl6
}



// WEBPACK FOOTER //
// ./src/api/baseUrl.js